var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('img',{staticClass:"errimg",attrs:{"src":require("../assets/img/nodata.png")}}),_c('p',[_vm._v("抱歉，没有其他可展示的数据哦")])])
}]

export { render, staticRenderFns }